import ButtonMultiClick from "@/components/Buttons/ButtonMultiClick";
import styles from "@/styles/Video.module.scss";
import { useCallback } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function DvrLive(_ref) {
  let {
    state
  } = _ref;
  const handleLiveEdge = useCallback(() => {
    state.updateResumePoint(-1);
  }, []);
  const handleStart = useCallback(() => {
    state.updateResumePoint(0.1);
  }, []);
  return /*#__PURE__*/_jsx("div", {
    className: styles.dvrlive,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.buttons,
      children: [/*#__PURE__*/_jsx(ButtonMultiClick, {
        fillColor: true,
        medium: true,
        onClick: handleLiveEdge,
        children: "\u30E9\u30A4\u30D6\u4F4D\u7F6E\u304B\u3089\u518D\u751F"
      }), /*#__PURE__*/_jsx(ButtonMultiClick, {
        fillColor: true,
        medium: true,
        onClick: handleStart,
        children: "\u6700\u521D\u304B\u3089\u518D\u751F"
      })]
    })
  });
}